import React from 'react';

const CreditIcon = () => (
  <svg
    width="30"
    height="25"
    viewBox="0 0 30 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.366943"
      y="0.844727"
      width="28.6449"
      height="23.451"
      rx="4"
      fill="#16FA48"
      fillOpacity="0.4"
    />
    <path
      d="M20.6809 9.18649C20.5762 9.08159 20.4519 8.99836 20.315 8.94158C20.1781 8.88479 20.0313 8.85556 19.8831 8.85556C19.7349 8.85556 19.5882 8.88479 19.4513 8.94158C19.3144 8.99836 19.19 9.08159 19.0854 9.18649L14.6948 13.5657L10.2929 9.17517C10.1882 9.07041 10.0638 8.9873 9.92691 8.93061C9.79003 8.87391 9.64332 8.84473 9.49516 8.84473C9.347 8.84473 9.20029 8.87391 9.06341 8.93061C8.92653 8.9873 8.80215 9.07041 8.69739 9.17517C8.59263 9.27994 8.50952 9.40431 8.45282 9.54119C8.39613 9.67807 8.36694 9.82478 8.36694 9.97294C8.36694 10.1211 8.39613 10.2678 8.45282 10.4047C8.50952 10.5416 8.59263 10.6659 8.69739 10.7707L13.8914 15.9647C14.3327 16.406 15.0456 16.406 15.4869 15.9647L20.6809 10.7707C20.7857 10.6671 20.8689 10.5438 20.9258 10.4078C20.9826 10.2719 21.0118 10.126 21.0118 9.9786C21.0118 9.83124 20.9826 9.68534 20.9258 9.54937C20.8689 9.4134 20.7857 9.29006 20.6809 9.18649Z"
      fill="#035415"
    />
  </svg>
);
export const TevIcon = () => (
  <svg
    width="29"
    height="25"
    viewBox="0 0 29 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="28.6895"
      y="24.7598"
      width="28"
      height="24"
      rx="4"
      transform="rotate(-180 28.6895 24.7598)"
      fill="#0068C8"
      fillOpacity="0.4"
    />
    <path
      d="M7.68945 10.7598H21.6895M7.68945 14.7598H21.6895"
      stroke="#024685"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DebitIcon = () => (
  <svg
    width="30"
    height="25"
    viewBox="0 0 30 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="29.0117"
      y="24.0928"
      width="28.6449"
      height="23.451"
      rx="4"
      transform="rotate(-180 29.0117 24.0928)"
      fill="#F5004A"
      fillOpacity="0.3"
    />
    <path
      d="M8.69777 15.751C8.80246 15.8559 8.92681 15.9391 9.0637 15.9959C9.20059 16.0527 9.34734 16.0819 9.49554 16.0819C9.64374 16.0819 9.79049 16.0527 9.92738 15.9959C10.0643 15.9391 10.1886 15.8559 10.2933 15.751L14.6839 11.3718L19.0857 15.7623C19.1905 15.8671 19.3149 15.9502 19.4518 16.0069C19.5886 16.0636 19.7353 16.0928 19.8835 16.0928C20.0317 16.0928 20.1784 16.0636 20.3153 16.0069C20.4521 15.9502 20.5765 15.8671 20.6813 15.7623C20.786 15.6576 20.8691 15.5332 20.9258 15.3963C20.9825 15.2594 21.0117 15.1127 21.0117 14.9646C21.0117 14.8164 20.9825 14.6697 20.9258 14.5328C20.8691 14.3959 20.786 14.2716 20.6813 14.1668L15.4873 8.97281C15.046 8.53149 14.3331 8.53149 13.8918 8.97281L8.69777 14.1668C8.59294 14.2704 8.50971 14.3937 8.45291 14.5297C8.3961 14.6656 8.36685 14.8115 8.36685 14.9589C8.36685 15.1063 8.3961 15.2522 8.45291 15.3881C8.50971 15.5241 8.59294 15.6474 8.69777 15.751Z"
      fill="#D3003F"
    />
  </svg>
);

export default CreditIcon;
